/*global ga*/
// export const logLegacy = () => () => ga('send', 'event', "Legacy", "fail");
// export const logPlatform = platform => () => ga('send', 'event', "Platform", platform);
// export const logImpression = () => () => ga('send', 'event', "Sponsor", "impression");

// Remove ga functions
export const logLegacy = () => () => {};
export const logPlatform = platform => () => {};
export const logImpression = () => () => {};
